'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './attendance-report.routes';

export class AttendanceReportComponent {
  constructor(AttendanceService, dialogs, $uibModal, $stateParams, Auth, DTOptionsBuilder, $timeout) {
    'ngInject';
    this.AttendanceService = AttendanceService;
    this.isAdmin = Auth.isAdminSync;

    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.$timeout = $timeout;

    let date = new Date(), y = date.getFullYear(), m = date.getMonth();
    this.from = new Date(y, m, 1);
    this.to = new Date(y, m + 1, 0);

    this.dtInstance = {};

    this.getData();

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('responsive', true)
      .withOption('order', [0, 'asc'])
      .withOption('pageLength', 50)
      .withOption('buttons',[{
        extend: 'excel',
        title: 'Attendance Report'
      },{
        extend: 'csv',
        title: 'Attendance Report'
      },{
        title: 'Attendance Report',
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'landscape',
        pageSize: 'LETTER'
      },'print'])
      .withBootstrap();
  }

  getData() {
    let from = new Date(this.from.getTime() - (this.from.getTimezoneOffset() * 60000 )).toISOString().split("T")[0];
    let to = new Date(this.to.getTime() - (this.to.getTimezoneOffset() * 60000 )).toISOString().split("T")[0];

    this.AttendanceService.getBetween({from: from, to: to}, data => {
      this.rawData = data;
      this.generate();
    });
  }

  formatDate(inputDate) {
    var date = new Date(inputDate);
    if (!isNaN(date.getTime())) {
      // Months use 0 index

      return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
    }
  }

  generate() {

    if (this.meetings)
      delete this.meetings;

    if (this.data)
      delete this.data;

    let meetings = [];
    let data = [];

    this.rawData = this.rawData.map(a => {a.meetingDate = this.formatDate(a.meetingDate); return a});

    console.log(this.rawData);

    this.rawData.forEach(attendance => {
      if (meetings.indexOf(attendance.meetingDate) === -1)
        meetings.push(attendance.meetingDate);
    });

    this.rawData.forEach(attendance => {

      let name = attendance.attendedBy;

      let fullName = (attendance.member) ? attendance.member.firstName + " " + attendance.member.lastName : "Former Member";

      if (attendance.type === 'sub') {
        name = attendance.subName;
        name += " (Sub for " + fullName + ")";
      } else if (attendance.type == 'guest') {
        name += " (Guest of " + fullName + ")";
      }

      let idx = data.findIndex(att => att.name == name);

      if (idx === -1) {
        let _att = {};
        _att[attendance.meetingDate] = new Date(attendance.signInTime);
        data.push({
          name: name,
          attendances: _att
        })
      } else {
        data[idx].attendances[attendance.meetingDate] = new Date(attendance.signInTime);
      }

    });

    this.meetings = meetings;
    this.data = data;

    console.log(this.dtInstance);
    this.$timeout(_ => {
      this.dtInstance.DataTable.draw();
    },500);

    /*
    this.meetings = ["01/10/2019", "01/17/2019", "01/24/2019", "01/31/2019"];
    this.data = [{
      name: "Aaron Pulley",
      attendances: {
        "01/10/2019": "8:06 AM",
        "01/17/2019": "7:48 AM",
        "01/24/2019": "9:30 AM",
        "01/31/2019": "7:43 AM"}
    }, {
      name: 'Lisa Ziemer',
      attendances: {
        "01/10/2019": "8:06 AM",
        "01/17/2019": "7:49 AM",
        "01/24/2019": "",
        "01/31/2019": "7:46 AM"}
    }, {
      name: 'Ronald Brodsky',
      attendances: {
        "01/10/2019": "",
        "01/17/2019": "7:50 AM",
        "01/24/2019": "9:32 AM",
        "01/31/2019": "7:46 AM"}
    }];
    */
  }

}

export default angular.module('conduuApp.attendanceReport', [uiRouter])
  .config(routes)
  .component('attendanceReport', {
    template: require('./attendance-report.html'),
    controller: AttendanceReportComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/attendance/report/attendance-report.component.js